/**
* GENERATED BY KRPC GEN - LESS MODIFY BY HAND
* home-service.ts  2026-08-26T09:15:21+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'krpc-base';

import type { DiamondAreqReq, BannerQuery, PromptRes, PopupRes, TrackPopupReq, Banner, PromptReq, PopupReq, MarqueeReq, MarqueeRes, MiniRank, CommonReq, DiamondArea, PopupListReq } from './wy-dto';

const _ = 'Home/';

export class HomeService {

  constructor(readonly r: RpcService) {}
  // 金刚区图标集合，根据app类型和cityCode获取
  appDiamond(d:DiamondAreqReq, m?: M): R<DiamondArea>{
    return this.r.async(_ + 'appDiamond', d, m);
  }
  // 不同位置的banner，根据cityCode获取
  banner(d:BannerQuery, m?: M): R<Array<Banner>>{
    return this.r.async(_ + 'banner', d, m);
  }
  // 获取会员卡购买人数（模糊处理）如：xxx人已购
  getVipBuyToast(m?: M): R<string>{
    return this.r.async(_ + 'getVipBuyToast', undefined, m);
  }
  // 通用跑马灯接口，通过场景类型scene区分
  marquee(d:MarqueeReq, m?: M): R<MarqueeRes>{
    return this.r.async(_ + 'marquee', d, m);
  }
  // 通用弹窗接口V1，通过场景类型scene区分
  popup(d:PopupReq, m?: M): R<PopupRes>{
    return this.r.async(_ + 'popup', d, m);
  }
  // 通用弹窗接口V2
  popupList(d:PopupListReq, m?: M): R<Array<PopupRes>>{
    return this.r.async(_ + 'popupList', d, m);
  }
  // 通用提示接口，通过场景类型scene区分
  prompt(d:PromptReq, m?: M): R<PromptRes>{
    return this.r.async(_ + 'prompt', d, m);
  }
  // 首页排行榜入口
  rankEntry(d:CommonReq, m?: M): R<Array<MiniRank>>{
    return this.r.async(_ + 'rankEntry', d, m);
  }
  // 通用弹窗事件上报. 只记录UID+弹窗信息ID+弹窗卡片ID维度的第一次请求
  trackPopup(d:TrackPopupReq, m?: M): R<boolean>{
    return this.r.async(_ + 'trackPopup', d, m);
  }
}
